if (!customElements.get('product-modal')) {
  customElements.define(
    'product-modal',
    class ProductModal extends ModalDialog {
      constructor() {
        super();
        this.touchStart = null;
        this.lastSwipeAt = 0;
        this.addEventListener('click', this.onModalClick.bind(this));
        this.addEventListener('touchstart', this.onTouchStart.bind(this), { passive: true });
        this.addEventListener('touchend', this.onTouchEnd.bind(this));
      }

      hide() {
        super.hide();
      }

      show(opener) {
        super.show(opener);
        this.showActiveMedia();
      }

      showActiveMedia() {
        const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute('data-media-id')}"]`);
        this.setActiveMedia(activeMedia);
      }

      getMediaItems() {
        const container = this.querySelector('[role="document"]');
        if (!container) return [];

        return Array.from(container.children).filter((element) => element.hasAttribute('data-media-id'));
      }

      getActiveMedia() {
        return this.getMediaItems().find((element) => element.classList.contains('active'));
      }

      setActiveMedia(activeMedia) {
        if (!activeMedia) return;

        this.getMediaItems().forEach((element) => {
          element.classList.remove('active');
        });
        const activeMediaTemplate = activeMedia.querySelector('template');
        const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
        activeMedia.classList.add('active');
        activeMedia.scrollIntoView();

        const container = this.querySelector('[role="document"]');
        container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

        if (
          activeMedia.nodeName == 'DEFERRED-MEDIA' &&
          activeMediaContent &&
          activeMediaContent.querySelector('.js-youtube')
        )
          activeMedia.loadContent();
      }

      showAdjacentMedia(direction) {
        const mediaItems = this.getMediaItems();
        const activeMedia = this.getActiveMedia();
        const activeIndex = mediaItems.indexOf(activeMedia);
        const nextMedia = mediaItems[activeIndex + direction];

        if (!nextMedia) return;
        this.setActiveMedia(nextMedia);
      }

      onModalClick(event) {
        if (!window.matchMedia('(max-width: 749px)').matches) return;
        if (Date.now() - this.lastSwipeAt < 500) return;
        if (event.target.closest('.product-media-modal__toggle')) return;

        const activeMedia = this.getActiveMedia();
        if (activeMedia && !activeMedia.contains(event.target)) this.hide();
      }

      onTouchStart(event) {
        if (!window.matchMedia('(max-width: 749px)').matches) return;
        if (event.touches.length !== 1) return;

        this.touchStart = {
          x: event.touches[0].clientX,
          y: event.touches[0].clientY,
        };
      }

      onTouchEnd(event) {
        if (!this.touchStart || !window.matchMedia('(max-width: 749px)').matches) return;
        if (!event.changedTouches.length) return;

        const deltaX = event.changedTouches[0].clientX - this.touchStart.x;
        const deltaY = event.changedTouches[0].clientY - this.touchStart.y;
        this.touchStart = null;

        if (Math.abs(deltaX) < 50 || Math.abs(deltaX) < Math.abs(deltaY) * 1.2) return;

        event.preventDefault();
        this.lastSwipeAt = Date.now();
        this.showAdjacentMedia(deltaX < 0 ? 1 : -1);
      }
    }
  );
}
